var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4165,
    transform: "translate(-136 -3872)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic:round-phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.82 10.1733L11.1267 9.97993C10.9276 9.95654 10.7258 9.97859 10.5364 10.0444C10.347 10.1102 10.175 10.2181 10.0334 10.3599L8.80669 11.5866C6.91429 10.6239 5.37607 9.08566 4.41336 7.19326L5.64669 5.95993C5.93336 5.67326 6.07336 5.27326 6.02669 4.86659L5.83336 3.18659C5.7957 2.86132 5.63967 2.56128 5.395 2.34366C5.15033 2.12604 4.83414 2.00606 4.50669 2.00659H3.35336C2.60003 2.00659 1.97336 2.63326 2.02003 3.38659C2.37336 9.07993 6.92669 13.6266 12.6134 13.9799C13.3667 14.0266 13.9934 13.3999 13.9934 12.6466V11.4933C14 10.8199 13.4934 10.2533 12.82 10.1733Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d6b48d5f1c861e5d783aef0e994e90ca.svg";
export { ForwardRef as ReactComponent };